import {RootState} from '../../rootReducer';

const notLoadedDeskAmenities = {status: 'NotLoaded', availableDeskAmenities: []};
const notLoadedActivityTypes = {status: 'NotLoaded', availableActivityTypes: []};

export const getAvailableDeskAmenityDataByBuildingId = (buildingId: string) => (state: RootState) =>
  state.data.typology.availableDeskAmenityData[buildingId] ?? notLoadedDeskAmenities;

export const getAvailableActivityTypeDataByBuildingId = (buildingId: string) => (state: RootState) =>
  state.data.typology.availableActivityTypeData[buildingId] ?? notLoadedActivityTypes;
